import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { tap } from 'rxjs';

import SessionExpiredService from '#services/session-expired/session-expired.service';

@Injectable()
export class SessionExpiredInterceptor implements HttpInterceptor {
  private readonly sessionExpiredService = inject(SessionExpiredService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    return next.handle(req).pipe(
      tap({
        error: (error) => {
          if (error instanceof HttpErrorResponse && error.status === 401) {
            this.sessionExpiredService.setSessionExpired();
          }
        },
      }),
    );
  }
}
